var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8347 6.83527H16.15V6.8H8.5V10.2H13.3038C12.6029 12.1792 10.7198 13.6 8.5 13.6C5.68352 13.6 3.4 11.3165 3.4 8.5C3.4 5.68352 5.68352 3.4 8.5 3.4C9.80007 3.4 10.9828 3.89045 11.8834 4.69157L14.2876 2.28735C12.7695 0.872525 10.7389 0 8.5 0C3.80587 0 0 3.80587 0 8.5C0 13.1941 3.80587 17 8.5 17C13.1941 17 17 13.1941 17 8.5C17 7.93007 16.9413 7.37375 16.8347 6.83527Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.980103 4.54367L3.77278 6.59175C4.52843 4.7209 6.35848 3.4 8.50005 3.4C9.80012 3.4 10.9829 3.89045 11.8835 4.69157L14.2877 2.28735C12.7696 0.872525 10.7389 0 8.50005 0C5.2352 0 2.40385 1.84322 0.980103 4.54367Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.49998 16.9999C10.6955 16.9999 12.6905 16.1597 14.1988 14.7933L11.5681 12.5672C10.686 13.238 9.60815 13.6008 8.49998 13.5999C6.28913 13.5999 4.41191 12.1902 3.70471 10.2229L0.932861 12.3585C2.33961 15.1112 5.19646 16.9999 8.49998 16.9999Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8347 6.83532H16.15V6.80005H8.5V10.2H13.3038C12.9685 11.142 12.3647 11.9651 11.5668 12.5677L11.5681 12.5669L14.1988 14.793C14.0127 14.9622 17 12.75 17 8.50005C17 7.93012 16.9413 7.3738 16.8347 6.83532Z",
    fill: "#1976D2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group 3.c8acd2ca1b9cd9d0eee53d4dabf6db43.svg";
export { ForwardRef as ReactComponent };